/**
 * Словник: it.
 * Згенеровано tool/gen_web_locales.py з lib/l10n/app_it.arb — руками не правити.
 *
 * ⚠️ Новий рядок: спершу в ARB усіх мов, потім ключ у en.ts і перегенерація.
 * Паритет ключів перевіряється на збірці (npm run check:i18n).
 */
export default {
  waiting: "⏳ In attesa dell’altro partecipante...",
  connectionLost: "Connessione persa",
  peerLeft: "👋 L’altro partecipante ha lasciato la chiamata",
  connectionError: "🚫 Errore di connessione",
  connectionFailedTryAgain: "🚫 Impossibile connettersi al server. Riprova.",
  reconnectionFailed: "🚫 Connessione persa. Impossibile ripristinarla dopo {attempts} tentativi.",
  connectionErrorWithDetails: "🚫 Errore di connessione: {error}",
  speakerLoud: "Alto",
  speakerEar: "Ricevitore",
  copyRoomId: "Copia ID stanza",
  share: "Condividi",
  linkCopied: "🔗 Link copiato!",
  idCopied: "🆔 ID copiato!",
  startMeeting: "Avvia riunione",
  chooseAction: "Scegli un’azione",
  createNewRoom: "Nuova stanza",
  scheduleCall: "Pianifica una chiamata",
  calendarOpened: "📅 Calendario aperto",
  linkCopiedToClipboard: "🔗 Link copiato negli appunti",
  enterRoomId: "ID della stanza",
  roomIdValidationError: "L’ID stanza può contenere solo lettere, numeri e trattini",
  joinRoom: "ENTRA",
  termsAndPrivacyHelp: "Termini e privacy | Aiuto",
  invite: "Invita",
  mySettings: "Le mie impostazioni",
  peerSettings: "Impostazioni interlocutore",
  blockRemoteControl: "Blocca il controllo remoto",
  iAgreeToTerms: "Accetto i termini del servizio",
  termsOfUse: "Termini d’uso",
  privacyPolicy: "Informativa sulla privacy",
  howToUse: "Come si usa",
  termsAcceptanceRequired: "Per usare il servizio devi accettare i termini",
  ok: "OK",
  permissionsRequired: "Autorizzazioni necessarie",
  permissionsNeededMessage: "Per funzionare correttamente, l’app ha bisogno delle seguenti autorizzazioni:",
  permissionsNote: "Nota: quando modifichi le autorizzazioni in Impostazioni, iOS riavvia l’app. È un comportamento normale.",
  permissionsEnableMessage: "Per continuare, attiva queste autorizzazioni nelle impostazioni del dispositivo.",
  cancel: "Annulla",
  openSettings: "Apri Impostazioni",
  websocketError: "Errore WebSocket",
  roomFull: "La stanza è piena",
  timeExpired: "Tempo scaduto",
  remaining: "rim.",
  mediaPermissionsRequired: "Le videochiamate richiedono l’accesso a fotocamera e microfono. Concedi le autorizzazioni nel browser.",
  mediaPermissionsRequiredMobile: "Le videochiamate richiedono l’accesso a fotocamera e microfono. Concedi le autorizzazioni nelle impostazioni dell’app.",
  browserSettings: "Impostazioni del browser",
  openAppSettings: "Apri impostazioni",
  grantPermissions: "Concedi autorizzazioni",
  permissionsNotGranted: "Autorizzazioni non concesse. Concedile per continuare.",
  permissionRequestError: "Errore nella richiesta delle autorizzazioni: {error}",
  camera: "Fotocamera",
  microphone: "Microfono",
  cameraDescription: "Per trasmettere il video",
  microphoneDescription: "Per trasmettere l’audio",
  continueWithoutPermissions: "Continua senza autorizzazioni",
  mediaPermissionsRequiredFallback: "Per le videochiamate servono le autorizzazioni per fotocamera e microfono. Concedile nelle impostazioni del browser.",
  mediaPermissionsRequiredMobileFallback: "Per le videochiamate servono le autorizzazioni per fotocamera e microfono. Concedile nelle impostazioni dell’app.",
  browserSettingsFallback: "Impostazioni del browser",
  openAppSettingsFallback: "Apri impostazioni",
  permissionsPermanentlyDenied: "Autorizzazioni negate in modo permanente. Attivale nelle impostazioni dell’app.",
  continueText: "Continua",
  mirror: "Specchio",
  fitContain: "Adatta",
  fitCover: "Riempi",
  switchCamera: "Cambia",
  block: "Blocca",
  pip: "PiP",
  mic: "Micro",
  video: "Video",
  speaker: "Vivavoce",
  readyToConnect: "Tutto pronto per chiamare?",
  startOneOnOne: "Avvia una videochiamata",
  createPrivateLink: "Link pronto in un attimo",
  welcomeExplainer: "Crea un link e invialo a chi vuoi. Si apre anche senza l’app.",
  joinHaveLink: "Hai un link?",
  joinFieldHint: "Incolla un link o un ID",
  roomInputInvalid: "Incolla un link di chiamata o un ID stanza (lettere, numeri e trattini)",
  guestTitle: "Hai ricevuto un invito a una videochiamata",
  guestBody: "La stanza è pronta. L’altra persona ti vedrà non appena entri.",
  guestJoin: "Entra",
  guestFreeNote: "Entrare è sempre gratis",
  guestCreateOwn: "Crea la mia stanza",
  guestInvalidTitle: "Questo link sembra danneggiato",
  guestInvalidBody: "Chiedi di nuovo il link o crea la tua stanza.",
  inviteCardTitle: "La tua stanza è pronta",
  inviteCardBody: "Invia il link alla persona con cui vuoi parlare",
  inviteShareLink: "Condividi link",
  inviteCopy: "Copia",
  inviteBrowserHint: "Si apre in qualsiasi browser. Non serve installare l’app.",
  inviteSentHint: "Inviato? L’altra persona comparirà qui non appena apre il link.",
  inviteShareMessage: "Entra nella mia videochiamata su One2One 👋\nApri semplicemente il link. Funziona nel browser, non devi installare nulla:\n{link}",
  copyLink: "Copia link",
  consentBannerText: "Possiamo raccogliere statistiche di utilizzo? Ci mostrano quali funzioni vengono usate. Il contenuto delle chiamate non è mai incluso.",
  consentAllow: "Consenti",
  consentDeny: "Non consentire",
  privacySettingsLink: "Impostazioni statistiche",
} as const;
